<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="futureBillings"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:item.id="{ item }">
        <span class="badge bg-primary">Not Paid</span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: {
    billings: {
      default: () => [],
    },
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  watch: {
    billings(newVal) {
      this.futureBillings = newVal;
    },
  },
  mounted() {
    this.futureBillings = this.billings;
  },

  data: () => ({
    futureBillings: [],
    headers: [
      { text: "SID", value: "sid" },
      { text: "Date", value: "date" },
      { text: "Description", value: "description" },
      { text: "Amount", value: "amount" },
      { text: "Status", value: "id" },
    ],
  }),
};
</script>
